<template>
  <ul class="cardListPublic">
    <li
      v-for="(v, i) in cardList"
      :key="i"
      :style="{ width: 100 / (cardList.length + 2) + '%' }"
    >
      <h5>{{ v.value | handleNumPublicFun }}</h5>
      <p>{{ v.name }}</p>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    cardList: {
      type: Array,
      default: () => {
        [];
      },
    },
  },
  data() {
    return {};
  },
  methods: {},
  created() {},
};
</script>

<style lang="scss" scoped>
.cardListPublic {
  width: 100%;
  height: 100%;
  @include setFlexCenter;
  li {
    // width: 25%;
    height: 90%;
    position: relative;
    @include setFlexColumn;
    justify-content: center;
    align-items: center;
    h5 {
      color: #28cccb;
      font-size: 30px;
    }
    p {
      color: #666;
    }
  }
  li:not(:last-child):before {
    content: "";
    height: 30%;
    border-left: 1px solid #e6e6e6;
    position: absolute;
    top: 35%;
    right: 0px;
  }
}
</style>
